import { PropsWithChildren } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from '@/lib/query-client';

import { useInitializeAuth } from '@/hooks';
import AppTheme from '@/lib/theme/AppTheme';

const ProvidersContent = ({ children }: PropsWithChildren) => {
  useInitializeAuth();

  return <>{children}</>;
};

export default function Providers({ children }: PropsWithChildren) {

  return (
    <AppTheme>
      <CssBaseline />

      <QueryClientProvider client={queryClient}>
        <ProvidersContent>
          {children}
        </ProvidersContent>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AppTheme>
  );
}